export const STYLE_EACH_ROW_WRAPPER =
  'w-full h-fit flex items-center flex-row gap-[25px]';
export const STYLE_CONTENT_WRAPPER =
  'w-fit h-full flex justify-center items-center flex-row gap-[16px]';
export const STYLE_ITEM_WRAPPER = 'w-[110px] flex justify-center flex-col';
